// extracted by mini-css-extract-plugin
export default {"strategyNameWrapper":"Strategy_strategyNameWrapper__-t0gK"};